//import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css';

import { BrowserRouter } from 'react-router-dom';

import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import userReducer from './store/reducers/user';
import searchReducer from './store/reducers/search';
import memberReducer from './store/reducers/member';
import serviceNowReducer from './store/reducers/serviceNow';
import referenceDataReducer from './store/reducers/referenceData';
import addAccountReducer from './store/reducers/addAccount';
import addEligibilityReducer from './store/reducers/addEligibility';
import personalInfoReducer from './store/reducers/personalInfo';
import agentActivityReducer from './store/reducers/agentActivity';
import reportingReducer from './store/reducers/reporting';
import timerReducer from './store/reducers/timerReducer';
import identityConfirmationReducer from './store/reducers/identityConfirmation';
import persistedSearchReducer from './store/reducers/persistedSearch';

console.log("env values", process.env.REACT_APP_COGNITO_AUTHORITY, process.env.REACT_APP_COGNITO_CLIENTID, process.env.REACT_APP_ADMIN_SERVICE_HOST)

const composeEnhancers = process.env.NODE_ENV==='development' || process.env.NODE_ENV==='stage'?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||compose:compose;

const rootReducer = combineReducers({
    usr: userReducer,
    search: searchReducer,
    member: memberReducer,
    serviceNow: serviceNowReducer,
    refData: referenceDataReducer,
    addAccount: addAccountReducer,
    addEligibility : addEligibilityReducer,
    personalInfo : personalInfoReducer,
    agentActivity: agentActivityReducer,
    reporting: reportingReducer,
    timer: timerReducer,
    identityConfirmation: identityConfirmationReducer,
    persistedSearch: persistedSearchReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

const app = (
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
);


ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
